var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { PNLTXN_EMPTY_VALIDATION, PNLTXN_HIDE_EMPTY_VALIDATION, PNL_TRANSACTION_ERROR, PNL_TRANSACTION_HIDE_ERROR, PNL_TRANSACTION_REPORT, PNL_TRANSACTION_SHOW_SHIMMER, EDIT_SPLIT_TXN_LOADER, PNL_ORIGINAL_TXNS, PNL_ORIGINAL_TXNS_LOADER, STOCK_DETAILS_SUMMARY, } from "../../interfaces/Reports/iPNLTransactionReport";
import { SCREENSTATE } from "@redux/interfaces/Reports/CoreReports/iHolding";
import { EREPORTSCREENSTATE } from "@domains/aggregates/interfaces/Reports/iHoldingReport";
var initState = {
    data: {
        pnl: "",
        editableTransactionCount: 0,
        pnLTransactionDetails: [],
    },
    stockDetails: {
        isin: "",
        displayName: "",
        quantity: "",
        lastTradedPrice: "",
        change: "",
        changePercentage: "",
        scripIdentifier: "",
        description: "",
        exchange: "",
        editableCount: 0,
        stockAssetType: undefined,
    },
    screenState: EREPORTSCREENSTATE.L1,
    goBackState: false,
    errorData: {
        error: null,
        isOpen: false,
    },
    txnStatus: {
        error: null,
        isOpen: null,
    },
    emptyValidation: {
        icon: null,
        message: null,
    },
    showTransactionShimmer: false,
    editTXNShimmer: false,
    pnlOriginalTxns: [],
    orgTxnStatus: {
        error: null,
        isOpen: null,
    },
    orgTxnLoader: false,
};
var pnltranasactionReport = function (state, action) {
    var _a, _b;
    if (state === void 0) { state = initState; }
    switch (action.type) {
        case PNL_TRANSACTION_REPORT:
            return __assign(__assign({}, state), { data: action.payload.data });
        case STOCK_DETAILS_SUMMARY:
            return __assign(__assign({}, state), { stockDetails: action.payload.stockDetails });
        case SCREENSTATE:
            return __assign(__assign({}, state), { screenState: action.payload.screenState, goBackState: action.payload.goBackState });
        case PNL_TRANSACTION_ERROR:
            return __assign(__assign({}, state), (_a = {}, _a[action.errorType] = action.payload.errorData, _a));
        case PNL_TRANSACTION_HIDE_ERROR:
            return __assign(__assign({}, state), (_b = {}, _b[action.errorType] = initState[action.errorType], _b));
        case PNLTXN_EMPTY_VALIDATION:
            return __assign(__assign({}, state), { emptyValidation: action.payload.emptyValidation });
        case PNLTXN_HIDE_EMPTY_VALIDATION:
            return __assign(__assign({}, state), { emptyValidation: initState.emptyValidation });
        case PNL_TRANSACTION_SHOW_SHIMMER:
            return __assign(__assign({}, state), { showTransactionShimmer: action.payload.showTransactionShimmer });
        case EDIT_SPLIT_TXN_LOADER: {
            return __assign(__assign({}, state), { editTXNShimmer: action.payload.editTXNShimmer });
        }
        case PNL_ORIGINAL_TXNS: {
            return __assign(__assign({}, state), { pnlOriginalTxns: action.payload.pnlOriginalTxns });
        }
        case PNL_ORIGINAL_TXNS_LOADER: {
            return __assign(__assign({}, state), { orgTxnLoader: action.payload.orgTxnLoader });
        }
        default:
            return __assign({}, state);
    }
};
export default pnltranasactionReport;
